var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 18,
    viewBox: "0 0 28 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1242 9.00077C27.1242 9.24941 27.0255 9.48787 26.8496 9.66368C26.6738 9.8395 26.4354 9.93827 26.1867 9.93827H4.07486L9.97548 15.837C10.0626 15.9242 10.1318 16.0277 10.179 16.1415C10.2261 16.2554 10.2504 16.3775 10.2504 16.5008C10.2504 16.624 10.2261 16.7461 10.179 16.86C10.1318 16.9739 10.0626 17.0774 9.97548 17.1645C9.88832 17.2517 9.78484 17.3208 9.67095 17.368C9.55707 17.4152 9.435 17.4395 9.31173 17.4395C9.18847 17.4395 9.0664 17.4152 8.95252 17.368C8.83863 17.3208 8.73515 17.2517 8.64798 17.1645L1.14798 9.66452C1.06068 9.57743 0.991411 9.47398 0.944148 9.36008C0.896886 9.24618 0.872559 9.12408 0.872559 9.00077C0.872559 8.87746 0.896886 8.75535 0.944148 8.64146C0.991411 8.52756 1.06068 8.4241 1.14798 8.33702L8.64798 0.837019C8.73515 0.749855 8.83863 0.680712 8.95252 0.633537C9.0664 0.586365 9.18847 0.562086 9.31173 0.562086C9.435 0.562086 9.55707 0.586365 9.67095 0.633537C9.78484 0.680712 9.88832 0.749855 9.97548 0.837019C10.0626 0.924185 10.1318 1.02766 10.179 1.14155C10.2261 1.25544 10.2504 1.3775 10.2504 1.50077C10.2504 1.62404 10.2261 1.7461 10.179 1.85999C10.1318 1.97388 10.0626 2.07735 9.97548 2.16452L4.07486 8.06327H26.1867C26.4354 8.06327 26.6738 8.16204 26.8496 8.33786C27.0255 8.51367 27.1242 8.75213 27.1242 9.00077Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.4c6268de67407a60d444ac3c0eee36e4.svg";
export { ForwardRef as ReactComponent };